<template>
  <el-row type="flex" justify="space-between">
    <el-col>
      <h3 class="title">{{ $t('header.title') }}</h3>
    </el-col>
    <el-col>
      <div style="text-align: right; margin-right: 20px;">
        <span class="user-text">{{userInfo && userInfo.realName}}</span>
        <span class="separator"/>
        <el-button type="text" @click="loginOut" class="link">
          {{ $t('header.logOut') }}
        </el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { userLogout } from '@/api/user';

export default {
  name: 'app-header',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
  },
  methods: {
    async loginOut() {
      try {
        await userLogout();
        this.$store.commit('user/removeToken');
        window.location.reload();
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
  .title {
    color: #377FEB;
    font-size: 20px;
  }
  .user-text {
    font-size: 14px;
    color: #555555;
  }
  .link {
    font-size: 14px;
    color: #169BD5;
  }
  .separator {
    display: inline-block;
    width: 1px;
    height: 20px;
    margin: 0 7px;
    vertical-align: middle;
    background: #e8e8e8;
  }
</style>
